
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:576)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.252 15.735l1.294 1.293h-.001l-1.293 1.58c3.163 3.304 3.163 8.619 0 12.066-3.307 3.447-8.912 3.591-12.506.287-3.45-3.304-3.594-8.906-.287-12.497l-1.293-1.293 1.293-1.293 1.294 1.293a8.185 8.185 0 014.167-1.58v-1.867h-1.724V12h5.318v1.724H25.79v1.723c1.438.144 2.876.719 4.17 1.58l1.293-1.292zM18.315 24.21a6.44 6.44 0 006.468 6.464c3.595 0 6.469-2.73 6.469-6.464a6.44 6.44 0 00-6.468-6.464 6.44 6.44 0 00-6.469 6.464zm6.468.143v-4.165a4.17 4.17 0 014.17 4.165 4.17 4.17 0 01-8.337 0h4.168z","fill":"#2FB95E"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:576","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:576"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:576","result":"shape"}})])])])
          )
        }
      }
    